import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import i18n from "shared/i18n";
import { Translation } from 'react-i18next';

import {connect} from "react-redux";
import { patchMobileAppsLink } from 'redux/links/actions';

import onClickOutside from "react-onclickoutside";

import InputField from 'components/elements/InputField';

import './MobileAppLinkText.css';

const ENTER_KEY = 13;


class MobileAppLinkText extends Component {
  static propTypes = {
    patchMobileAppsLink: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    location: PropTypes.object,
    linkId: PropTypes.number.isRequired,
    pacthMobileAppsLinkError: PropTypes.object,
  };

  static defaultProps = {
    location: null,
    pacthMobileAppsLinkError: null,
  };

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);

    if (this.props.name) {
      this.setState({
        initialValue: this.props.name,
        currentValue: this.props.name,
      });
    }

    if (this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.name !== this.props.name) {
      this.setState({ currentValue: this.props.name });
    }

    if (prevProps.location !== this.props.location) {
      const isInputFocused = this.useQuery(this.props.location.search);
      if (isInputFocused) {
        this.inputEditFieldRef.current.focus();
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  inputEditFieldRef = createRef();

  changeValue = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== initialValue &&
      currentValue.length > 0 &&
      !this.executeValidation()
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('name', currentValue);
      this.props.patchMobileAppsLink(this.props.linkId, form);
    }
  };

  onEnterClick = (event) => {
    if (event.keyCode === ENTER_KEY) {
      this.changeValue();
    }
  };

  useQuery = param => {
    return new URLSearchParams(param).get('focus');
  };

  handleClickOutside = () => {
    this.changeValue();
  };

  executeValidation = () => {
    const { pacthMobileAppsLinkError } = this.props;
    const { currentValue } = this.state;

    if (pacthMobileAppsLinkError && pacthMobileAppsLinkError.name) {
      return pacthMobileAppsLinkError.name;
    }
    if (currentValue === '' ) {
      return i18n.t("Button text should not be empty");
    } else if (currentValue && currentValue.length > 30 ) {
      return i18n.t("Button text must has no more than 30 characters");
    }
    return null;
  };

  render() {
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="mobile-app-link-text__component">
            <div className="input-wrapper">
              <InputField
                value={currentValue}
                onChange={(e) => {
                  e.preventDefault();
                  this.setState({ currentValue: e.target.value });
                }}
                customRef={this.inputEditFieldRef}
                error={this.executeValidation() && {text: this.executeValidation()}}
              />
            </div>
            <div className="subtext">{t("Button Text")}</div>
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    pacthMobileAppsLinkError: state.linksReducer.pacthMobileAppsLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    patchMobileAppsLink,
  },
)(onClickOutside(MobileAppLinkText));
